import Vue from "vue";
import Router from "vue-router";
/* 引入页面 */
import Pages from "./Pages";
import common from "../api/common";
import api from "../api";
import store from "../api/store";

var wx = require("weixin-js-sdk");

Vue.use(Router);

var routes = [];
routes = routes.concat(Pages);
routes.push({
  path: "*",
  redirect: {
    name: "homepage_Index",
  },
});

var router = new Router({
  mode: "history",
  routes,
});

var initWx = function(to, from, next) {
  if (to.matched.length > 0 && to.matched[0].components.default.title) {
    document.title = to.matched[0].components.default.title;
  }

  api.user.getShareParam(
    location.href,
    data => {
      console.log(data);
      var shareParam = data.shareParam;
      //初始化wx配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: shareParam.appId, // 必填，公众号的唯一标识
        timestamp: shareParam.timestamp, // 必填，生成签名的时间戳
        nonceStr: shareParam.nonceStr, // 必填，生成签名的随机串
        signature: shareParam.signature, // 必填，签名
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "chooseImage",
          "previewImage",
        ], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"],
      });
    },
    r => {
      console.log(r.msg);
    }
  );
};

router.beforeEach((to, from, next) => {
  // filter 有坑 ，造成定位问题， 直接加在html
  // if(to.path === '/pages/homepage/Index'){
  //   document.documentElement.style.filter = 'grayscale(1)'
  // }else{
  //   document.documentElement.style.filter = 'inherit'
  // }

  /* 路由发生变化修改页面title */
  if (to.matched.length > 0 && to.matched[0].components.default.title) {
    document.title = to.matched[0].components.default.title;
  }
  /* 路由发生变化修改页面body的class */
  if (to.matched.length > 0) {
    var bodyClass = to.matched[0].components.default.bodyClass;
    if (bodyClass) {
      document.getElementsByTagName("body")[0].className = bodyClass;
    } else {
      document.getElementsByTagName("body")[0].className = "";
    }
  }

  //页面滚动到顶部
  window.scrollTo(0, 0);
  next();
});

router.afterEach((to, from, next) => {
  var baiduTongji = common.baiduTongji;
  //如果启用百度统计
  if (!!baiduTongji) {
    setTimeout(() => {
      var _hmt = _hmt || [];
      (function() {
        //每次执行前，先移除上次插入的代码
        document.getElementById("baidu_tj") &&
          document.getElementById("baidu_tj").remove();
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?" + baiduTongji;
        hm.id = "baidu_tj";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }, 0);

    setTimeout(() => {
      initWx(to, from, next);
    }, 100);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js